import React, { useState } from "react";
import { Row } from "react-bootstrap";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import CreditWithOutReference from "./CreditWithOutReference";
import CreditWithReference from "./CreditWithReference";
import DebitWithReference from "./DebitWithReference";

function AddMemo(props) {
  const orderId = props.history?.location?.state?.orderId || null;
  const [state, setState] = useState(0);
  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-4 ">
                <div className="f24_700_HelveticaNeue">Add Memo</div>
              </div>
              <Row>
                <div className="col-md-6 col-12">
                  <Row>
                    <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
                      <a
                        class={`seating-icon-box-section text-decoration-none ${
                          state === 0 && "active"
                        }`}
                        href="#"
                        onClick={() => {
                          setState(0);
                        }}
                      >
                        <div>
                          <div>
                            {/* <span class="badge custom-icon-button-badge custom-badge-position-pending">
                            0
                          </span> */}
                          <img
                            src={
                              state === 1
                                ? require("../../../assets/images/Icon/Group 57690.svg")
                                : require("../../../assets/images/Icon/Group 57689.svg")
                            }
                            alt="icon"
                            class="img-fluid inside-image-button"
                            style={{ minWidth: "12.5625vh" }}
                          />
                        </div>
                        <p
                          class={`icon-bottom-text  ${state === 0 && `icon-bottom-text-active`
                            }`}
                        >
                          Credit Memo
                        </p>
                      </div>
                    </a>
                  </div>
                  <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center" style={{maxWidth:"100%"}}>
                    <a
                      aria-current="page"
                      class={`seating-icon-box-section text-decoration-none ${state === 1 && `active`
                        }`}
                        href="#"
                        onClick={() => {
                          setState(1);
                        }}
                      >
                        <div>
                          <div>
                            {/* <span class="badge custom-icon-button-badge custom-badge-position-seating">
                            2
                          </span> */}
                          <img
                            alt="icon"
                            src={
                              state === 0
                                ? require("../../../assets/images/Icon/Group 57690.svg")
                                : require("../../../assets/images/Icon/Group 57689.svg")
                            }
                            class="img-fluid"
                            style={{ minWidth: "12.5625vh" }}
                          />
                        </div>
                        <p
                          class={`icon-bottom-text  ${state === 1 && `icon-bottom-text-active`
                            }`}
                          >
                            Debit Memo
                          </p>
                        </div>
                      </a>
                    </div>
                  </Row>
                </div>
              </Row>
              <div className="mt-3">
                {state === 0 && <CreditMemo orderId={orderId} />}
              </div>
              <div className="mt-3">{state === 1 && <DebitMemo />}</div>
            </div>
          </div>
        </Row>
      </div>
    </React.Fragment>
  );
}

export default AddMemo;

const DebitMemo = (props) => {
  const [state, setState] = useState(0);
  return (
    <div>
      <div class="d-flex flex-wrap align-items-center">
        <button
          type="button"
          onClick={() => {
            setState(0);
          }}
          class={`px-0 mr-5 text-grayLink f12-500 ${
            state === 0 && `active`
          } btn btn-link`}
        >
          With Reference
        </button>
      </div>
      <div>{state === 0 && <DebitWithReference />}</div>
    </div>
  );
};

const CreditMemo = (props) => {
  const [state, setState] = useState(0);
  return (
    <div>
      <div class="d-flex flex-wrap align-items-center">
        <button
          type="button"
          onClick={() => {
            setState(0);
          }}
          class={`px-0 mr-5 text-grayLink f12-500 ${
            state === 0 && `active`
          } btn btn-link`}
        >
          With Reference
        </button>
        <button
          type="button"
          onClick={() => {
            setState(1);
          }}
          class={`px-0 mr-5 text-grayLink f12-500 ${
            state === 1 && `active`
          } btn btn-link`}
        >
          Without Reference
        </button>
      </div>
      <div>
        {state === 0 && <CreditWithReference orderId={props.orderId} />}
        {state === 1 && <CreditWithOutReference />}
      </div>
    </div>
  );
};
